module.exports = __webpack_public_path__ + "assets/img/fah-logo.3259bad44711bf9a4af863089a6fe49c.svg";